import { useTranslation } from "react-i18next";
import { ZoomIn } from "lucide-react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";

/**
 * Ảnh thu nhỏ bấm được để phóng to.
 *
 * Tách ra dùng chung vì đã có hai danh sách cần đúng một thứ này (Sản phẩm và
 * Đơn mẫu). Ảnh trong bảng chỉ 28px — không phóng to được thì nó là trang trí,
 * mà nhân viên mẫu nhìn ảnh để nhận ra mặt hàng nhanh hơn đọc mã.
 */
export function ImageThumbButton({
  src,
  label,
  onOpen,
}: {
  src: string;
  /** Đọc cho trình đọc màn hình: ảnh CỦA CÁI GÌ, không phải "ảnh". */
  label: string;
  onOpen: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className="group relative size-7 shrink-0 overflow-hidden rounded-sm border border-line bg-surface focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand"
      aria-label={label}
    >
      <img src={src} alt="" className="size-full object-cover" />
      <span className="absolute inset-0 grid place-items-center bg-ink/50 text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100">
        <ZoomIn className="size-3.5" />
      </span>
    </button>
  );
}

/**
 * Hộp xem ảnh phóng to. Dùng chung cho mọi danh sách có ảnh, để cách xem ảnh ở
 * Sản phẩm và ở Đơn mẫu không trôi thành hai kiểu khác nhau.
 */
export function ImagePreviewModal({
  eyebrow,
  title,
  caption,
  src,
  onClose,
}: {
  eyebrow: string;
  title: string;
  caption?: string | null;
  src: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Modal
      eyebrow={eyebrow}
      title={title}
      closeLabel={t("common.close")}
      onClose={onClose}
      className="max-w-4xl"
    >
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex min-h-0 flex-1 items-center justify-center bg-sunken/40 p-4 sm:p-6">
          <img
            src={src}
            alt={caption || title}
            className="max-h-[calc(100dvh-13rem)] max-w-full rounded-md object-contain shadow-[var(--shadow-card)]"
          />
        </div>
        <div className="flex shrink-0 items-center justify-between gap-4 border-t border-line bg-surface px-5 py-3.5">
          <p className="min-w-0 truncate text-sm text-ink-soft">{caption || title}</p>
          <Button type="button" variant="secondary" size="sm" onClick={onClose}>
            {t("common.close")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
